module.exports = __webpack_public_path__ + "static/media/shop_60.8e380534.png";